import update from 'immutability-helper'
import {
  TEMPLATE_FLAG,
  SPECIAL_FLAG,
  REF_FLAG,
  REF_BLOCK_FLAG,
  traverseSchema,
  getValidProps,
  sourceElmsEqual,
  mergeIntoSource,
  splitSourceTemplates,
  excludeSource,
  chainJoin
} from './utils'
// const clone = x => JSON.parse(JSON.stringify(x))

const rootHydrate = async function(includeString, chosenSource){
  // console.log(includeString, chosenSource)
  // console.log('splitting include string', includeString, REF_FLAG)
  let [type, name, id] = includeString.split(REF_FLAG)
  // console.log('rootHydrate file', type, name, id)
  const file = await chosenSource[type].getTyped({_id: id, name})
  if( !file ) throw new Error(`rootHydrate: No file fetched for string ${includeString}`)
  // console.log('returning file', file)
  return {type, id: file._id, name: file.name, file: file.content.getData(), rawFile: file}
}

const getItem = (includes, address) => {
  const isStitch = address.split(REF_BLOCK_FLAG).length > 1
  let t
  if( !isStitch ) {
    let [type, name, id] = address.split(REF_FLAG)
    // console.log('looking at include of type %s, id %s, version %s', type, id, version)
    // console.log('repo', includes)
    // console.log(includes[type], includes[type][id], includes[type][id][version])
    // console.log('trying to get include from', location, name)
    // console.log('in', templates)
    // console.log('parse includes', includes)
    if( includes[type] ){
      if( includes[type][name] ) t = includes[type][name]
      else if( includes[type][id] ) t = includes[type][id]
      // console.log('looking at include', t)
      if( !t ){
        console.warn('NON-EXISTING INCLUDE REFERENCED!', type, id)
        console.log(includes)
        throw new Error('No bueno')
      }
      if( t.content ) t = t.content
      else if( t._content ) t = t._content
    } else {
      throw new Error(`No type ${type}`)

    }
  } else {
    if( includes._stitched[address] ) t = includes._stitched[address]
    else throw new Error(`No address "${address}"`)
  }
  return t


}

// Include filling function just to follow getTemplate's footsteps
const getInclude = function(includes, address, includeType){
  // console.log('BEGIN get include for address', address)
  // console.log('getInclude', includes, address, includeType)
  if( typeof address === 'string' ){
    // Address is a string, which means it's either an address or a shorthand
    if( address.includes(REF_FLAG) ){
      // String is an actual address, parse and locate

      // check if we have to do merges
      let t  = null
      const isRef = address.includes(REF_BLOCK_FLAG )
      // console.log('check include addr', address)
      if( isRef ){
        try {
          t = getItem(includes, address)
        } catch(e) {
          const blocks = address.split(REF_BLOCK_FLAG)
          t = chainJoin(blocks.map(block => getItem(includes, block)))
          includes._stitched = includes._stitched || {}
          includes._stitched[address] = t
        }
      } else {
        t = getItem(includes, address)
      }


      // have include at this point; iterate through include to recursively
      // fill it in case if the include has includes, etc
      // console.log('have item', t)
      let fullInclude = []
      if( includeType === 'schema' ) {
        for( let item of t[0][includeType]){
          // Recursively scan all templates thus retrieved
          let retrievedItem = getInclude(includes, item, includeType)
          fullInclude = update(fullInclude, {
            '$push': retrievedItem
          })
        }
        return fullInclude.map(stringShorthandToObject).map(v => {
          if(!v._include || v._include === address ) v._include = address
          else {
            v._originalInclude = v._include
            v._include = address
          }
          return v
        })
      } else if( includeType === 'source' ){
        // console.log('returning', t)

        if( isRef ){
          return {...t, _include: address}
        } else {
          return {...t[0][includeType], _include: address}

        }
      }

      // console.log('gt returning full template', fullTemplate)

    } else {
      // Address is a template or shorthand, leave as is
      return [address]
    }
  } else if(Array.isArray(address)){
    // Address is a sub-array of addresses
    let res = []
    address.forEach(elm => {
      res = res.concat(getInclude(includes, elm, includeType))
    })
    return res
  } else if( typeof address === 'object' ){
    // Address is not a string at all but a fully fledged element. Check that it
    // itself does not have any unexpanded templates, and return it in an array.
    // console.log('looking at', address)
    let props = getValidProps(address)
    let returnedElement = address
    // if( props.length )
      // console.log('checking element %s for props', _name, props)

    for( let prop of props ){
      let target = address[prop]
      if( Array.isArray(target) ){
        // console.log('found array to run map template on, to be assigned to prop',prop, target)
        returnedElement[prop] = []
        target.forEach(elm => {
          returnedElement[prop] = returnedElement[prop].concat(getInclude(includes, elm, includeType))
        })
      }
    }
    // console.log('the RETURNING ELEMENT to be WRAPPED INTO AN ARRAY is', returnedElement)
    return [returnedElement]
  }


}

// Goes through compressed source and hydrates it only, without expanding,
// given an existing, pre-filled hash table of includes
const hydrateSource = function(src, includes){
  // console.log('hydrating source', src)
  const scanAddresses = (srcs)=>{
    // console.log('scanning layer', JSON.parse(JSON.stringify(srcs)))
    // console.log('scanning layer', srcs)
    if( Array.isArray(srcs) ){
      // console.log('array detected, iterating on these sources', srcs)
      return srcs.map(scanAddresses)
    } else if( typeof srcs === 'string' ){
      // console.log('getting template for source', srcs)
      return getInclude(includes, srcs, 'source')
    }
    if( !srcs ) return []
    // console.log('about to get props from', srcs)
    let sourceAddresses = getValidProps(srcs)
    for( let address of sourceAddresses ){
      // Address cannot start with '_' or IGNORE_FLAG, those are ignored
      // fields (name, etc)
      // console.log('scan', address, srcs, srcs[address])
      if( !address ){
        // console.log('no address, deleting source and continuing')
        delete srcs[address]
        continue
      }
      let children = srcs[address], newChildren
      if( !children ) {
        // console.log('no children, deleting source and continuing')
        delete srcs[address]
        continue
      }
      // determine if children is actually a terminating array full of objects,
      // or a sub-object for separation of areas of source
      if( Array.isArray(children) ){
        // this is an array of objects and not a sub-object
        // console.log('children are an array, scanning', children)
        newChildren = []
        for( let childIdx in children ){
          // `children` is an array of mixed strings and objects
          // this could either be a shorthand name, or a full object
          // (possibly with children)
          let child = children[childIdx]
          let updatedChildren = []
          if( typeof child === 'string' ){
            // turns a child that's a template into an array of that template
            // wraps a non-template child in an array for consistensy's sake
            // scans the result recursively to make sure we get any templates
            // that were delivered as a result of fetching previous templates
            // console.log('string detected, iterating on child by fetching string via template', child)
            updatedChildren = getInclude(includes, child, 'source').map(scanAddresses)
            updatedChildren._include = child
            // console.log('received updated children after fetching string "%s" via template', child, clone(updatedChildren))
            // console.log('for string', child)
          } else if( Array.isArray(child) ){
            // console.log('array detected, mapping children', child)
            updatedChildren = child.map(scanAddresses)
          } else if( typeof child === 'object' ){
            // child is already an object, so it should be scanned recursively
            // console.log('object detected, iterating on child', child)
            updatedChildren = [scanAddresses(child)]
            // console.log('received recursed children', updatedChildren)
            // console.log('for single object', child)
          }
          // console.log('adding children to newChildren', updatedChildren)
          // check if any children that we just extracted already exist in the
          // list of new children; if they do, merge them
          // console.log('checking matching names', newChildren, updatedChildren)
          for( let childIdx in newChildren ){
            let newChild = newChildren[childIdx]
            let existing = -1
            let isObject = typeof newChild === 'object'
            if( isObject )
              existing = updatedChildren.findIndex(e => e._name === newChild._name )
            else
              existing = updatedChildren.indexOf(newChild)
            // console.log('found newChild.name (%s) in updatedChildren: %s', newChild._name, existing, updatedChildren)
            if( ~existing ) {
              // console.log('FOUND EXISTING ITEM', newChild._name)
              // console.log(clone(newChildren))
              if( isObject ){
                newChildren = update(newChildren, {
                  [childIdx]: {'$set': mergeIntoSource(newChild, updatedChildren[existing])}
                })
                // console.log(clone(newChildren))
              } else {
                newChildren.push(newChild)
              }
              updatedChildren = update(updatedChildren, {
                '$splice': [[existing, 1]]
              })
            }
          }
          // console.log('new children pre-update', JSON.parse(JSON.stringify(newChildren)))
          // console.log('updated children', clone(updatedChildren))
          newChildren = update(newChildren, {
            '$push': updatedChildren
          })
        }

        // for( let newChildIdx in newChildren ){
        //   let newChild = newChildren[newChildIdx]
        //   newChild._parent = srcs
        //   newChildren[newChildIdx] = newChild
        // }
      } else if( typeof children === 'object' ) {
        // This is an object full of sub-objects; each sub-object needs to be
        // scanned separately and re-filed under its name
        // console.log('Scanning object', children)
        let props = getValidProps(children)
        newChildren = {}
        for( let subObject of props ){
          let child = children[subObject]
          newChildren[subObject] = scanAddresses(child)
        }
      } else if( typeof children === 'string' ){
        // console.log('getting string based include', includes, children)
        newChildren = getInclude(includes, children, 'source')
        // console.log('resultant children', newChildren)
        const keys = Object.keys(newChildren)
        if( newChildren && keys.length) {
          // extract source wrapper
          // newChildren = newChildren[keys[0]]
          newChildren._include = children
        }
        // console.log('got source include', newChildren)

      }
      // Record our changes to this part of the source
      srcs = update(srcs, {
        [address]: {'$set': newChildren}
      })

    }
    return srcs
  }

  if( src ) {
    // console.log('sending this to be hydrated', src, includes)
    const res = scanAddresses(src)
    // console.log('returning this hydrated source', res)
    return res
  }
  return {}
}

// Goes through any form of schema and hydrates it without expanding,
// given an existing, pre-filled hash table of includes
const hydrateSchema = function(schema, includes){
  // console.log('hydrating schema with includes', schema, includes.inspection_schemas['5e80c4c7c514595c6df4da2a'][0]._content[0])
  // console.log('got includes in hydrateSchema', includes.inspection_schemas['5e80c4c7c514595c6df4da2a'][0]._content[0].schema[0]._include)

  if( !schema || !schema.length ) return schema
  const scanSchemaLayer = function(layer){
    // console.log('scan layer', layer)
    let newLayer = []
    if( typeof layer === 'string' ) {
      newLayer = getInclude(includes, layer, 'schema')
    } else {
      for( const item of layer ){
        let newItem = {}
        if( typeof item === 'object' ) {
          newItem = item
          if( item.children ) {
            newItem = update(newItem, {
              'children': { '$set': scanSchemaLayer(item.children)}
            })
          }
          newLayer.push(newItem)
        } else if( typeof item === 'string' && item.includes(REF_FLAG) ){
          let includeContents = getInclude(includes, item, 'schema')
          if(includeContents && includeContents.length){
            // console.log('hydrating inside the include')
            includeContents = hydrateSchema(includeContents, includes)
            newLayer = [...newLayer, ...includeContents.map(itm => update(itm, {'_include': {'$set': item}}))]
          }
        } else {
          newItem = item
          newLayer.push(newItem)
        }
      }
    }

    return newLayer
  }
  return scanSchemaLayer(schema)
}

// No idea how or even whether to make this work for now...
const hydrateTree = function(tree, includes){
  return tree
}

// Recursively fills out a template based on address, then transforms that
// into an expanded object form and returns it inside an array
const getTemplate = (templates, address)=>{
   // console.log('BEGIN get template for address', address)
  // console.log(address)
  if( typeof address === 'string' ){
    // Address is a string, which means it's either an address or a shorthand
    if( address.includes(TEMPLATE_FLAG) ){
      // String is an actual address, parse and locate
      let [location, name] = address.split(TEMPLATE_FLAG)
      // console.log('trying to get template from', location, name)
      // console.log('in', templates)
      let t = templates[location] && templates[location][name]
      if( !t ){
        console.warn('NON-EXISTING TEMPLATE REFERENCED!', location, name)
        console.log(templates)
        throw new Error('No bueno')
      }
      // have template at this point; iterate through template to recursively
      // fill it in case if the template has templates, etc
      let fullTemplate = []
      for( let templateItem of t){
        // Recursively scan all templates thus retrieved
        if( templateItem === address ) continue
        let retrievedItem = getTemplate(templates, templateItem)
        fullTemplate = update(fullTemplate, {
          '$push': retrievedItem
        })
      }
      // console.log('gt returning full template', fullTemplate)
      return fullTemplate.map(stringShorthandToObject).map(v => {
        if(!v._template || v._template === address ) v._template = address
        else {
          v._originalTemplate = v._template
          v._template = address
        }
        return v
      })
    } else {
      // String is just shorthand, wrap and return
      return [address].map(stringShorthandToObject)
    }
  } else if(Array.isArray(address)){
    // Address is a sub-array of addresses
    let res = []
    address.forEach(elm => {
      res = res.concat(getTemplate(templates, elm))
    })
    return res
  } else if( typeof address === 'object' ){
    // Address is not a string at all but a fully fledged element. Check that it
    // itself does not have any unexpanded templates, and return it in an array.
    // console.log('looking at', address)
    let props = getValidProps(address)
    let returnedElement = address
    // if( props.length )
      // console.log('checking element %s for props', _name, props)

    for( let prop of props ){
      let target = address[prop]
      if( Array.isArray(target) ){
        // console.log('found array to run map template on, to be assigned to prop',prop, target)
        returnedElement[prop] = []
        target.forEach(elm => {
          returnedElement[prop] = returnedElement[prop].concat(getTemplate(templates, elm))
        })
      }
    }
    // console.log('the RETURNING ELEMENT to be WRAPPED INTO AN ARRAY is', returnedElement)
    return [returnedElement]
  }

}

// Turns a string "shorthand" into a fully fledged JSON object
const stringShorthandToObject = (testItem)=>{
  // should not work with templates
  if( typeof testItem === 'object' ) return testItem
  else if( typeof testItem === 'string' ) return {_name: testItem}
  throw new Error('Zoinks')
}

// Transforms the template/flat version of JSON into an expanded one
const expandSource = (src)=>{
  if( !src ) return null
  const {templates, source} = splitSourceTemplates(src)
  const scanAddresses = (srcs)=>{
    // console.log('expanding layer', JSON.parse(JSON.stringify(srcs)))
    // console.log('scanning layer', srcs)
    if( Array.isArray(srcs) ){
      // console.log('array detected, iterating on these sources', srcs)
      return srcs.map(scanAddresses)
    } else if( typeof srcs === 'string' ){
      // console.log('getting template for source', srcs)
      return getTemplate(templates, srcs)[0]
    }
    if( !srcs ) return []
    // console.log('about to get props from', srcs)
    let sourceAddresses = getValidProps(srcs)

    for( let address of sourceAddresses ){
      // Address cannot start with '_' or IGNORE_FLAG, those are ignored
      // fields (name, etc)
      // console.log('scan', address)
      if( !address ){
        // console.log('no address, deleting source and continuing')
        delete srcs[address]
        continue
      }
      let children = srcs[address], newChildren
      if( !children ) {
        // console.log('no children, deleting source and continuing')
        delete srcs[address]
        continue
      }
      // determine if children is actually a terminating array full of objects,
      // or a sub-object for separation of areas of source
      if( Array.isArray(children) ){
        // this is an array of objects and not a sub-object
        // console.log('children are an array, scanning', children)
        newChildren = []
        for( let childIdx in children ){
          // `children` is an array of mixed strings and objects
          // this could either be a shorthand name, or a full object
          // (possibly with children)
          let child = children[childIdx]
          let updatedChildren = []
          if( typeof child === 'string' ){
            // turns a child that's a template into an array of that template
            // wraps a non-template child in an array for consistensy's sake
            // scans the result recursively to make sure we get any templates
            // that were delivered as a result of fetching previous templates
            // console.log('string detected, iterating on child by fetching string via template', child)
            updatedChildren = getTemplate(templates, child).map(scanAddresses)

            // console.log('received updated children after fetching string "%s" via template', child, clone(updatedChildren))
            // console.log('for string', child)
          } else if( Array.isArray(child) ){
            // console.log('array detected, mapping children', child)
            updatedChildren = child.map(scanAddresses)
          } else if( typeof child === 'object' ){
            // child is already an object, so it should be scanned recursively
            // console.log('object detected, iterating on child', child)
            updatedChildren = [scanAddresses(child)]
            // console.log('received recursed children', updatedChildren)
            // console.log('for single object', child)
          }
          // console.log('adding children to newChildren', updatedChildren)
          // check if any children that we just extracted already exist in the
          // list of new children; if they do, merge them
          // console.log('checking matching names', newChildren, updatedChildren)
          for( let childIdx in newChildren ){
            let newChild = newChildren[childIdx]

            let existing = updatedChildren.findIndex(e => e._name && e._name === newChild._name )
            if( ~existing ) {
              // console.log('FOUND EXISTING ITEM', newChild._name)
              // console.log(newChild)
              // console.log(updatedChildren)
              // console.log(updatedChildren[existing])
              // console.log(clone(newChildren))
              newChildren = update(newChildren, {
                [childIdx]: {'$set': mergeIntoSource(newChild, updatedChildren[existing])}
              })
              // console.log(clone(newChildren))
              updatedChildren = update(updatedChildren, {
                '$splice': [[existing, 1]]
              })
            }
          }
          // console.log('new children pre-update', JSON.parse(JSON.stringify(newChildren)))
          // console.log('updated children', clone(updatedChildren))
          newChildren = update(newChildren, {
            '$push': updatedChildren
          })
        }

        // for( let newChildIdx in newChildren ){
        //   let newChild = newChildren[newChildIdx]
        //   newChild._parent = srcs
        //   newChildren[newChildIdx] = newChild
        // }
      } else if( typeof children === 'object' ) {
        // This is an object full of sub-objects; each sub-object needs to be
        // scanned separately and re-filed under its name
        // console.log('Scanning object', children)
        let props = getValidProps(children)
        newChildren = {}
        for( let subObject of props ){
          let child = children[subObject]
          newChildren[subObject] = scanAddresses(child)
        }
        if( children._include ){
          newChildren._include = children._include
        }
      } else if( typeof children === 'string'){
        // This is a ref to another language. Leave it as it is.
        newChildren = children
      }
      // Record our changes to this part of the source
      srcs = update(srcs, {
        [address]: {'$set': newChildren}
      })

    }
    return srcs
  }
  if( source ) {
    // console.log('expanding source', source)

    let res = scanAddresses(source)
    const templates = expandTemplates(source)
    if( templates && Object.keys(templates).length ) {
      res._templates = templates
    }
    // console.log('post-expansion templates', res._templates)
    // console.log('expanded source', res)
    return res
  }
  return []
}

const expandTemplates = (source)=>{
  if( !source ) return null
  let templates = source._templates
  if( !templates ) return {}
  // console.log('got template')
  let res = {}
  let tplZones = Object.keys(templates)
  // console.log('looking at', templates)
  for( let zone of tplZones ){
    // console.log(zone)
    let zonedTemplates = templates[zone]
    let tplNames = Object.keys(zonedTemplates)
    res[zone] = res[zone] || {}
    for( let name of tplNames ){
      res[zone][name] = res[zone][name] || []
      let itemList = zonedTemplates[name]
      for( let tplItem of itemList ){
        res[zone][name] = res[zone][name].concat(getTemplate(templates, tplItem))
      }
    }
  }
  return res
}

// Turns source back into a shorthand version for easier export to excel
// Should be able to handle both shorthand and expanded versions
const compressSource = (fullSrc) => {
  // console.log('requesting source compression with template', JSON.parse(JSON.stringify(src)))
  // console.log(src)
  // let myTemplates = {}
  if( !fullSrc ) return null
  const includes = []
  // console.log('begin compress source', JSON.parse(JSON.stringify(src)))
  const {templates, source} = splitSourceTemplates(fullSrc)

  let currentParent = ''
  // console.log('compressing source', JSON.parse(JSON.stringify(source)))
  const scanAddresses = (src, checkTemplateName) => {
    // console.log(src)
    const sourceAddresses = getValidProps(src)
    const specialProps = Object.keys(src).filter(e => e[0] === SPECIAL_FLAG)
    // if( specialProps.length && specialProps[0] === '!faveId' ) console.log('got spec props', specialProps)
    // if( checkTemplateName ){
      // console.log('compression in checkTemplateName mode')
      // console.log(`scanning source addresses`, sourceAddresses)

    // }
    let newSrc = {}
    if( typeof src === 'string' ) {
      return src
    }
    for( let address of sourceAddresses ){
      let newChildren = []
      let subElement = src[address]
      if( Array.isArray(subElement) ){
        currentParent = address
        for( let child of subElement ){
          let newChild = scanAddresses(child, checkTemplateName)
          if( typeof newChild !== 'string' || !newChildren.includes(newChild) ){
            // either a non-basic element was returned, or a template that is
            // not yet included in the new children; add this element
            newChildren.push(newChild)
          }
        }
      } else if(typeof subElement === 'object') {
        // console.log(src, address, subElement)
        // console.log('attempting to iterate')
        currentParent = address
        newChildren = scanAddresses(subElement, checkTemplateName)
      } else if(subElement) {
        // already minified
        newChildren = subElement
        if( subElement.includes(REF_FLAG) ){
          if( !includes.includes(subElement) ) includes.push(subElement)
        }
      }

      newSrc = update(newSrc, {
        [address]: {'$set': newChildren}
      })
    }
    for( let specialAddr of specialProps ){
      newSrc = update(newSrc, {
        [specialAddr]: {'$set': src[specialAddr]}
      })
    }
    if( src._mask ){
      // masked item, so it must be non-basic regardless of children
      newSrc = update(newSrc, {
        _mask: {'$set': src._mask},
        _name: {'$set': src._name}
      })

    } else if( sourceAddresses.length === 0 && specialProps.length === 0 ) {
      // item has no mask, no children, and no special props, therefore it must
      // be basic
      // console.log('record basic')
      // if( specialProps.length && specialProps[0] === '!faveId' ) console.log('record basic')
      newSrc = src._name
    } else if( src._name ) {
      // item fails one of the above, so it is non-basic and needs a name
      // if( specialProps.length && specialProps[0] === '!faveId' )console.log('record nonbasic')
      newSrc = update(newSrc, {
        _name: {'$set': src._name}
      })
    }
    // if( checkTemplateName ){
      // console.log('scanning templates with current parent %s and item',currentParent, src)
    // }
    if( src._template ){
      // if( typeof newSrc !== 'object' ) {
      //   newSrc = {_name: newSrc}
      // }
      // newSrc = update(newSrc, {
      //   '$unset': ['_template'],
      //   '_originalTemplate': {'$set': src._template}
      // })

      // found template; add this template to template list, and return its name
      let [tplZone, tplName] = src._template.split(TEMPLATE_FLAG)
      // if( checkTemplateName ){
        // console.log('scanning templates with current parent %s and name %s',currentParent, tplName)
      // }
      if( checkTemplateName && tplName === currentParent ){
        // if this is true, we are not filling templates, we are scanning them
        newSrc = update(newSrc, {
          '$unset': ['_template', '_originalTemplate']
        })
        return [newSrc]
      }
      // console.log('processing template in %s %s', tplZone, tplName, newSrc)
      templates[tplZone] = templates[tplZone] || {}
      let tplTarget = templates[tplZone][tplName]
      if( !tplTarget ){
        // console.log('added template to list', tplZone, tplName)
        templates[tplZone][tplName] = [newSrc]
      } else {
        let contentTarget = newSrc._name || newSrc
        let expandedTpl = []
        tplTarget.forEach(item => {
          if( typeof item === 'string' && item.includes(TEMPLATE_FLAG) ){
            let expanded = getTemplate(templates, item)
            expandedTpl = expandedTpl.concat(expanded)
          } else {
            expandedTpl.push(item)
          }
        })
        // console.log('looking for either %s or %s in', contentTarget, src._template, expandedTpl)

        let tplIdx = expandedTpl.findIndex(elm => typeof elm === 'string'?
          elm === contentTarget:
          elm._name === contentTarget
        )
        if( !~tplIdx ){
          // console.log('template element did not exist, adding it to %s %s', tplZone, tplName, newSrc)
          templates[tplZone][tplName].push(newSrc)
        } else {
          // template exists in the template list, check if the item we have is
          // the same as the one in the template
          if( !sourceElmsEqual(newSrc, expandedTpl[tplIdx]) ){
            // console.log('source elms arent equal for', newSrc, expandedTpl[tplIdx])
            let diff = excludeSource(expandedTpl[tplIdx], newSrc)
            diff._name = newSrc._name
            if(newSrc._mask) diff._mask = newSrc._mask

            // console.log('received diff', diff)
            return diff
          } else {
            // console.log('sources are equal', newSrc, tplTarget[tplIdx])
            return src._template
          }
        }

      }
      return src._template
    }

    if( src._include ){
      if(!includes.includes(src._include)) includes.push(src._include)
      return src._include
    }
    // if( specialProps.length && specialProps[0] === '!faveId' ) console.log('returning', newSrc)
    return newSrc
  }
  let srcs = []
  // console.log('pulled templates', templates)

  if( source ) {
    // console.log('scanning source', templates)
    srcs = scanAddresses(source)
    // console.log('received', templates)
    if( srcs ){
      // console.log('about to scan addresses on', templates)
      const t = scanAddresses(templates, true)
      if( t && Object.keys(t).length )
        srcs._templates = t

    }
    // console.log('compressed source into', srcs, includes)
    return [srcs, includes]
  }
  return []
}

// Shorthand for tree is to assign a string to the content. This expands this
// tree from that shape to its full shape with content as arrays of objects.
const expandTree = (tree) => {
  if( !tree ) return null
  let leafNames = Object.keys(tree)
  for( let leafName of leafNames ){
    if(!tree[leafName]) continue
    let cont = tree[leafName].content
    if( cont ) {
      // console.log('expansion of %s with type of content %s:', leafName, typeof cont, cont)
      let exp = cont
      if( typeof cont === 'string' ){
        exp = expandContent(cont)
        // console.log('updating %s to expanded form', leafName, exp)
        // tree[leafName].content = expandContent(cont)
      } else if( Array.isArray(cont) ){
        exp = cont.map( elm => {
          if(typeof elm === 'string' ) return {_name: elm}
          return elm
        })
      }
      tree = update(tree, {
        [leafName]: {
          content: { '$set':  exp}
        }
      })
    }
  }
  // verification round if schema and source are provided
  // if (schema && source) {
  //   console.log('concluding expansion on tree, iterating controls', tree)
  //   traverseSchema(schema, source, tree, (ctrl, curSrc, chain, t, parentItem) => {
  //     console.log(ctrl, tree[ctrl.name])
  //   })
  // }
  // console.log('returning expanded tree', tree)
  return tree
}

const expandContent = content => {
  if( typeof content === 'string') return [{_name: content}]
  return content
}

// Compresses tree back down to the old (easier to manage) format.
const compressTree = (tree, basicTrim) => {
  if (!tree) return null
  let leafNames = Object.keys(tree)
  for( let leafName of leafNames ){
    if( tree[leafName] && tree[leafName].content ) {
      let cont = tree[leafName].content
      const upd = {}
      if( typeof cont === 'object' ){
        upd.content = { '$set': compressContent(cont) }
      }
      let unsetArr = ['source', 'idx', 'updated', '_parent', 'sourceAddress', 'fullSourceAddress']
      if( !basicTrim ) unsetArr.push('label')
      upd['$unset'] = unsetArr
      tree = update(tree, {
        [leafName]: upd
      })
    }
  }
  return [tree, []]
}

const compressContent = content => {
  if( typeof content !== 'object' ) return content
  if( content.length === 1 ) return content[0]._name
  else if( content.length > 1 ) return content.map(obj => {
    if( typeof obj === 'object' ) return obj._name
    else return obj
  })
  // else if( Array.isArray(content) && content.length < 1 ){
  //   console.log('nullifying content', content)
  //   return null
  // }
  else return content
}


// Expands schema from current state to having object-based and arg-delineated
// options
const expandSchema = target => {
  if( !target ) return null
  // console.log('expanding schema', target)
  let {schema} = traverseSchema(target, {}, {}, control => {
    if( control  ){
      // console.log('expand control', control)
      if( control.options ) {
        // console.log('control has options to expand', control.options)
        const expanded = expandOptions(control.options)
        // console.log('expanded into', expanded)
        control.options = expanded
        return {control}
      }
    }
  })
  // console.log('FINISHED SCHEMA', schema)
  return schema
}

const compressSchema = target => {
  // console.log('compressing schema', target)
  if( !target ) return null
  // const compressed = JSON.parse(JSON.stringify(target))
  const includes = []
  // let {schema} = traverseSchema(compressed, {}, {}, control => {
  //   if( control  ){
  //     if( control.options ) control.options = compressOptions(control.options)
  //     return {control}
  //   }
  // })
  const scanSchemaLayer = function(layer){
    // console.log(layer)
    // if( !Array.isArray(layer)) return layer
    // console.log('scanning layer', layer)
    let newLayer = []
    if( typeof layer === 'string' ){
      newLayer = layer
      if( !includes.includes(newLayer) ) includes.push(newLayer)
    } else {
      let keys = Object.keys(layer)
      let len = keys.length
      // console.log('layer is object with keys', len)
      if( layer && len){
        for( const itemIdx of keys ){
          let item = layer[itemIdx]
          let newItem = {}
          // console.log('looking at item', item)
          if( typeof item === 'object' ) {
            newItem = item
            if( item._include ) {
              newItem = item._include
              if( !includes.includes(newItem) ) includes.push(newItem)
            } else {
              // console.log('considering item w/options?', item)
              if( item.options ) {
                newItem = update(newItem, {
                  'options': {'$set': compressOptions(item.options)}
                })
              }
              if( item.children ) {
                newItem = update(newItem, {
                  'children': { '$set': scanSchemaLayer(item.children)}
                })
              }
            }
            newLayer.push(newItem)
          } else {
            // console.log('item is not an object', typeof item, REF_FLAG)
            newLayer.push(item)
            if( item.includes(REF_FLAG) && !includes.includes(item) ){
              includes.push(item)
            }
          }
        }
      }

      newLayer = [...new Set(newLayer)]
    }
    // remove duplicate include declarations
    return newLayer
  }
  // console.log('compressing schema', target)
  const res = scanSchemaLayer(target)
  // console.log('compressed schema into', res, includes)
  return [res, includes]
}

const compressOptions = function(options){
  if( !options || !options.length ) return options
  else {
    const compressed = options.map(
      expandedOption =>
        typeof expandedOption === 'object'?
        expandedOption._original?
        expandedOption._original:
        expandedOption._name:
        expandedOption
      )
    return compressed
  }
}

const expandOptions = function(options){
  // Ensure options exist, and turn them into a split of name/argument objects
  if( !options || !options.length ) return []
  const newOptions = []
  for( const rawOption of options ){
    if( !rawOption ) continue
    if( typeof rawOption === 'object' ) {
      newOptions.push(rawOption)
      continue
    }
    let arr = rawOption.split(':')
    let obj = { _original: rawOption }
    for( let argIdx = 0; argIdx < arr.length; argIdx++ ){
      const curItem = arr[argIdx]
      if( argIdx === 0 ) {
        obj._name = curItem
      } else {
        obj[`arg${argIdx}`] = curItem
      }
    }
    newOptions.push(obj)
  }
  // console.log('expand options into', newOptions)
  return newOptions
}

if( typeof window !== 'undefined' ) window._ms_trans = {
  expandSource,
  expandTree,
  expandContent,
  expandSchema,
  expandTemplates,

  compressTree,
  compressSource,
  compressSchema,

  rootHydrate,
  hydrateSource,
  hydrateSchema,
  hydrateTree
}

export {
  expandSource,
  expandTree,
  expandContent,
  expandSchema,
  expandTemplates,

  compressTree,
  compressSource,
  compressSchema,

  rootHydrate,
  hydrateSource,
  hydrateSchema,
  hydrateTree
}
